module.exports = __webpack_public_path__ + "static/icon-19d52cb375928ee17a9c5e9507446eb2.png";